import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TabPanel, a11yProps } from '../../ui';
import Sms from './sms/sms';
import Email from './email/email';
import { useModuleAccess } from 'hooks/useModuleAccess';

export default function Messaging() {
    const [value, setValue] = React.useState(0);
    const moduleAccess = useModuleAccess();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} >
                    <Tab label="SMS" {...a11yProps('messaging',0)} />
                    {moduleAccess.isEnabled('email') && (
                        <Tab label="Email" {...a11yProps('messaging',1)} />
                    )}
                </Tabs>
            </Box>
            <TabPanel idfor='SMS' value={value} index={0}>
                <Sms />
            </TabPanel>
            {moduleAccess.isEnabled('email') && (
                <TabPanel idfor='Email' value={value} index={1}>
                    <Email />
                </TabPanel>
            )}
        </Box>
    );
}
